import { defineMessages, type MessageDescriptor } from 'react-intl-next';

import { type TypeFilterValueKey } from '../../../../../common/utils/filters/constants';

export const typeLabels: Record<'all' | TypeFilterValueKey, MessageDescriptor> = defineMessages<
	TypeFilterValueKey | 'all'
>({
	all: {
		id: 'dynamic-cards-search-page.filter.type.all',
		defaultMessage: 'All',
		description:
			'All filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	document: {
		id: 'dynamic-cards-search-page.filter.type.documents',
		defaultMessage: 'Documents',
		description:
			'Document filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	spreadsheet: {
		id: 'dynamic-cards-search-page.filter.type.spreadsheet',
		defaultMessage: 'Spreadsheets',
		description:
			'Spreadsheets filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	presentation: {
		id: 'dynamic-cards-search-page.filter.type.presentation',
		defaultMessage: 'Presentations',
		description:
			'Presentations filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	repository: {
		id: 'dynamic-cards-search-page.filter.type.repository',
		defaultMessage: 'Repositories',
		description:
			'Repository filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	'pull-request': {
		id: 'dynamic-cards-search-page.filter.type.pull-request',
		defaultMessage: 'Pull requests',
		description:
			'Pull request filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	branch: {
		id: 'dynamic-cards-search-page.filter.type.branch',
		defaultMessage: 'Branches',
		description:
			'Branch filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	commit: {
		id: 'dynamic-cards-search-page.filter.type.commit',
		defaultMessage: 'Commits',
		description:
			'Commit filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	conversation: {
		id: 'dynamic-cards-search-page.filter.type.conversation',
		defaultMessage: 'Channels',
		description:
			'Channels filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	message: {
		id: 'dynamic-cards-search-page.filter.type.message',
		defaultMessage: 'Messages',
		description:
			'Message filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	video: {
		id: 'dynamic-cards-search-page.filter.type.video',
		defaultMessage: 'Videos',
		description:
			'Video filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	design: {
		id: 'dynamic-cards-search-page.filter.type.design',
		defaultMessage: 'Designs',
		description:
			'Design filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	page: {
		id: 'dynamic-cards-search-page.filter.type.page',
		defaultMessage: 'Pages',
		description:
			'Page filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	blogpost: {
		id: 'dynamic-cards-search-page.filter.type.blogpost',
		defaultMessage: 'Blog posts',
		description:
			'Blog posts filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	attachment: {
		id: 'dynamic-cards-search-page.filter.type.attachment',
		defaultMessage: 'Attachments',
		description:
			'Attachment filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	space: {
		id: 'dynamic-cards-search-page.filter.type.space',
		defaultMessage: 'Spaces',
		description:
			'Space filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	whiteboard: {
		id: 'dynamic-cards-search-page.filter.type.whiteboard',
		defaultMessage: 'Whiteboards',
		description:
			'Whiteboard filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	issue: {
		id: 'dynamic-cards-search-page.filter.type.issue',
		defaultMessage: 'Issues',
		description:
			'Issue filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	project: {
		id: 'dynamic-cards-search-page.filter.type.project',
		defaultMessage: 'Projects',
		description:
			'Project filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	goal: {
		id: 'dynamic-cards-search-page.filter.type.goal',
		defaultMessage: 'Goals',
		description:
			'Goal filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	tag: {
		id: 'dynamic-cards-search-page.filter.type.tag',
		defaultMessage: 'Tags',
		description:
			'tag filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	'web-page': {
		id: 'dynamic-cards-search-page.filter.type.web-page',
		defaultMessage: 'Web pages',
		description:
			'Webpage filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	comment: {
		id: 'dynamic-cards-search-page.filter.type.comment',
		defaultMessage: 'Comments',
		description:
			'Comment filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	database: {
		id: 'dynamic-cards-search-page.filter.type.database',
		defaultMessage: 'Databases',
		description:
			'Database filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	embed: {
		id: 'dynamic-cards-search-page.filter.type.embed',
		defaultMessage: 'Smart Links',
		description:
			'Smart Link filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	folder: {
		id: 'dynamic-cards-search-page.filter.type.folder',
		defaultMessage: 'Folders',
		description:
			'Folder filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	calendar: {
		id: 'dynamic-cards-search-page.filter.type.calendar',
		defaultMessage: 'Calendars',
		description:
			'Calendars filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	'space-calendar': {
		id: 'dynamic-cards-search-page.filter.type.space-calendar',
		defaultMessage: 'Space calendars',
		description:
			'Space calendars filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	answer: {
		id: 'dynamic-cards-search-page.filter.type.answer',
		defaultMessage: 'Answers',
		description:
			'Answers filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	question: {
		id: 'dynamic-cards-search-page.filter.type.question',
		defaultMessage: 'Questions',
		description:
			'Questions filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	component: {
		id: 'dynamic-cards-search-page.filter.type.component',
		defaultMessage: 'Components',
		description:
			'Component filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	'work-item': {
		id: 'dynamic-cards-search-page.filter.type.work-item',
		defaultMessage: 'Work items',
		description:
			'Work item filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	board: {
		id: 'dynamic-cards-search-page.filter.type.board',
		defaultMessage: 'Board',
		description:
			'Board filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
	card: {
		id: 'dynamic-cards-search-page.filter.type.card',
		defaultMessage: 'Card',
		description:
			'Card filter type option in the Build Dynamic Cards modal that appears when the user clicks the View Current Filters button in a dynamic cards configuration section',
	},
});
